// actions
export var GET_SHOP_DETAIL = 'GET_SHOP_DETAIL';
export var GET_GROUPS = 'GET_GROUPS';
export var GET_PRODUCTS_IN_SHOP = 'GET_PRODUCTS_IN_SHOP';
export var TOGGLE_POPUP = 'TOGGLE_POPUP';
export var RESET_VENUE_DETAIL = 'RESET_VENUE_DETAIL'; // mutations

export var MUTATE_SHOP_DETAIL = 'MUTATE_SHOP_DETAIL';
export var MUTATE_PRODUCTS_IN_SHOP = 'MUTATE_PRODUCTS_IN_SHOP';
export var MUTATE_PAGING_IN_SHOP = 'MUTATE_PAGING_IN_SHOP';
export var MUTATE_PAGE_LOADING_IN_SHOP = 'MUTATE_PAGE_LOADING_IN_SHOP';
export var MUTATE_PAGE_NUMBER = 'MUTATE_PAGE_NUMBER';
export var MUTATE_GROUPS = 'MUTATE_GROUPS';
export var MUTATE_POPUP_STATUS = 'MUTATE_POPUP_STATUS'; // getters

export var GETTER_SHOP_BASIC = 'GETTER_SHOP_BASIC';
export var GETTER_SHOP_PRODUCTS = 'GETTER_SHOP_PRODUCTS';
export var GETTER_SHOP_PAGING = 'GETTER_SHOP_PAGING';
export var GETTER_SHOP_GROUPS = 'GETTER_SHOP_GROUPS';
export var GETTER_SHOP_PHONES = 'GETTER_SHOP_PHONES';
export var GETTER_SHOP_SHOWPOPUP = 'GETTER_SHOP_SHOWPOPUP';